module.exports = __webpack_public_path__ + "assets/img/block-right-4eb60ad0.png";